class SortArrayPipe {
  transform(list, key, asc = true) {
    return list.slice().sort((a, b) => {
      let aValue = a[key];
      let bValue = b[key];

      if (typeof aValue === "string") {
        aValue = aValue.toLowerCase();
      }
      if (typeof bValue === "string") {
        bValue = bValue.toLowerCase();
      }

      if (aValue < bValue) {
        return asc ? -1 : 1;
      }

      if (aValue > bValue) {
        return asc ? 1 : -1;
      }

      return 0;
    });
  }
}

const sortArrayPipe = new SortArrayPipe();
export default sortArrayPipe;
